import moment from "moment";
import React from "react";

const ImagePreview = props => {
  let { name, uploadDate, size, isFileType, uploadCss, preview, isMsIcon } =
    props.item;
  let mb = 1024 * 1024;
  let file_size =
    size >= mb
      ? `${(size / mb).toFixed(2)}mb`
      : `${(size / 1024).toFixed(2)}kb`;
  // console.log('props: ', props)
  if (!props.singleItemPreview) {
    return (
      <span
        className={`imagePreviewContainer ${
          isMsIcon ? "isMsIconContainer" : ""
        }`}
      >
        <img
          className={`${isMsIcon ? "storiesGridMsIcon" : ""}`}
          src={preview}
        />
        <div className={`${uploadCss} imagePreviewTxt`}>
          <div className="imgPreviewTitle">{name}</div>
          {/* <div className="imgPreviewDate">
                    {moment(uploadDate).format('MMM DD, YYYY')}
                </div> */}
          <div className="imgPreviewSize">{file_size}</div>
          <div className="imgPreviewFileType">{isFileType}</div>
        </div>
      </span>
    );
  } else {
    return (
      <div className={`${uploadCss} imagePreviewTxt link-variant-preview`}>
        <div className="imgPreviewTitle">{name}</div>
        {/* <div className="imgPreviewDate">
            {moment(uploadDate).format('MMM DD, YYYY')}
        </div> */}
        <div className="imgPreviewSize">{file_size}</div>
        <div className="imgPreviewFileType">{isFileType}</div>
      </div>
    );
  }
};

export default ImagePreview;
